import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import { LoadingDots } from "../Components/LoadingDots";
import expensesHeadService from "../Services/expensesHead";
import Dropdown from "../Components/Dropdown";
import SecondaryButton from "../Components/SecondaryButton";
import { FiPlus } from "react-icons/fi";

const AddExpensesHead = () => {
  const navigate = useNavigate();
  const [responseError, setResponseError] = useState("");
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState({
    head_title: "",
    type: "",
  });

  const [errors, setErrors] = useState({
    head_title: false,
    type: false,
  });

  const [regex, setRegex] = useState({
    head_title: /.{1,50}$/,
    type: /.{1,50}$/,
  });

  const handleChange = (v, n) => {
    setResponseError("");
    setData((d) => ({ ...d, [n]: v }));
    if (v.length > 0) {
      setErrors((prevState) => ({ ...prevState, [n]: false }));
    }
  };

  const handleSubmit = () => {
    let hasError = false;
    Object.keys(data).map((v) => {
      if (!regex[v]?.test(data[v])) {
        setErrors((prevState) => ({ ...prevState, [v]: true }));
        hasError = true;
      }
    });

    if (hasError) {
      toast.error("Please fill the form correctly", { id: "1" });
    } else {
      setLoading(true);
      expensesHeadService.create(data).then((res) => {
        setLoading(false);
        toast.success("Expenses Head Added Successfully", { id: "2" });
        navigate("/expenses");
      });
    }
  };

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      handleSubmit();
    }
  };
  return (
    <main className="mx-10 mt-2 p-6 rounded-3xl border border-gray-200 shadow-lg bg-white min-h-[calc(100vh-48px)]">
      <p className="font-bold text-3xl text-secondary text-center mt-10">
        Add Expense Head
      </p>
      <div className="mt-10 px-80">
        <div className="grid grid-cols-1 gap-2 md:grid-cols-2 md:gap-4">
          <div>
            <label className={`primary-label`}>Expense Head</label>
            <input
              value={data.head_title}
              name="head_title"
              onChange={(e) => handleChange(e.target.value, e.target.name)}
              onKeyDown={handleKeyDown}
              className={`primary-input ${
                errors["head_title"] ? "border-red-600" : "border-gray-300"
              }`}
            />
          </div>
          <div>
            <label className={`primary-label`}>Head Type</label>
            <Dropdown
              selected={data.type}
              placeholder="Select Type"
              onChange={(value) => handleChange(value, "type")}
              options={[
                { label: "GENERAL", value: "GENERAL" },
                { label: "SALARY", value: "SALARY" },
                { label: "OTHER", value: "OTHER" },
              ]}
            />
          </div>
        </div>
        <div className="flex items-center justify-center mt-8">
          <SecondaryButton
            text={loading ? <LoadingDots /> : "Add"}
            Icon={FiPlus}
            color="!px-16"
            onClick={() => handleSubmit()}
          />
        </div>
      </div>
    </main>
  );
};

export default AddExpensesHead;
